import AdministrationService from "../../services";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { hasError } from "@/utils/utils";
export default {
  namespaced: true,
  state: {
    loading: false,
  },
  getters: {
    loading(state) {
      return state.loading;
    },
  },
  mutations: {
    setLoading(state, val) {
      state.loading = val;
    },
  },

  actions: {
    async deleteHoldGeneralBodyMeeting({ commit }, id) {
      commit("setLoading", true);
      try {
        const res = await AdministrationService.deleteHoldGeneralBodyMeeting(
          id
        );

        if (hasError(res.status)) {
          throw res.statusText;
        }
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم حذف عقد الاجتماع بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
        return Promise.reject();
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
